import { Cost } from "./cost";
import { ItemCategory } from "./item-category";

export abstract class EquipmentItem {
    constructor(
        public name: string,
        public damage: string,
        public rating: string,
        public shieldHitPoints: string,
        public weight: string,
        public durability: string,
        public design: string,
        public notes: string,
        public hands: string,
        public range: string,
        public availability: number,
        costString: string) {

        this.category = '';
        this.subCategory = '';
        this.isAvailable = undefined;
        this.availabilityRollResults = '';

        this.cost = Cost.parse(costString);
    }

    public category: string;
    public subCategory: string;
    public cost: Cost;
    public isAvailable: boolean | undefined;
    public availabilityRollResults: string;

    public get isAvailableString(): string {
        if(this.isAvailable === undefined) {
            return '';
        }
        return this.isAvailable ? 'Available' : 'Not available';
    }

    /**
     * CSS class used to display this item, based on availability
     */
    public get availabilityClass(): string {
        if(this.isAvailable === undefined) {
            return '';
        }
        return this.isAvailable ? 'available' : 'not-available';
    }

    public get shouldShowDamage(): boolean {
        return ItemCategory.shouldShowDamage(this.category);
    }

    public get shouldShowRating(): boolean {
        return ItemCategory.shouldShowRating(this.category);
    }

    public get shouldShowShieldHitPoints(): boolean {
        return ItemCategory.shouldShowShieldHitPoints(this.category);
    }

    public get shouldShowDurability(): boolean {
        return ItemCategory.shouldShowDurability(this.category);
    }

    public get shouldShowDesign(): boolean {
        return ItemCategory.shouldShowDesign(this.category);
    }
     
    public get shouldShowHands(): boolean {
        return ItemCategory.shouldShowHands(this.category);
    }

    public get shouldShowRange(): boolean {
        return ItemCategory.shouldShowRange(this.category);
    }
}

export class Weapon extends EquipmentItem {
    constructor(
        name: string,
        damage: string,
        weight: string,
        durability: string,
        design: string,
        notes: string,
        hands: string,
        range: string,
        availability: number,
        costString: string) {

        super(name, damage, '', '', weight, durability, design, notes, hands, range, availability, costString);
    }
}

export class Armour extends EquipmentItem {
    constructor(
        name: string,
        rating: string,
        durability: string,
        weight: string,
        design: string,
        notes: string,
        availability: number,
        costString: string) {

        super(name, '', rating, '', weight, durability, design, notes, '', '', availability, costString);
    }
}

export class Shield extends EquipmentItem {
    constructor(
        name: string,
        rating: string,
        shieldHitPoints: string,
        weight: string,
        design: string,
        notes: string,
        availability: number,
        costString: string) {

        super(name, '', rating, shieldHitPoints, weight, '', design, notes, '', '', availability, costString);
    }
}

export class Gear extends EquipmentItem {
    constructor(
        name: string,
        weight: string,
        notes: string,
        availability: number,
        costString: string) {

        super(name, '', '', '', weight, '', '', notes, '', '', availability, costString);
    }
}
